module.exports = __webpack_public_path__ + "img/noData.a4ba9f7c.png";